import React, { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"
import { useTranslation } from "react-i18next"
import { Box, Paper, styled } from "@mui/material"

import Table from "components/ui/Table"
import { DATE_TYPE, MONEY_TYPE, STRING_TYPE, LINK_TYPE } from "config"
import { PurchasedProductListType, PurchasedProductType } from "types"
import { withPurchasedProducts } from "hocs/features/withPurchasedProducts"

type Props = {
  items: PurchasedProductListType
}

const PurchasedProducts = ({ items }: Props) => {
  const { t } = useTranslation()

  const HEADER = [
    {
      label: t("features.purchased_products.table.date"),
      field: "date",
      format: DATE_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.purchased_products.table.sum"),
      field: "sum",
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.purchased_products.table.description"),
      field: "description",
      format: STRING_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.purchased_products.table.download"),
      field: "document_link",
      format: LINK_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.purchased_products.table.invoice"),
      field: "invoice_link",
      format: LINK_TYPE,
      minWidth: 100,
    },
  ]

  return (
    <Container data-testid="purchased-products-list">
      <Card elevation={0}>
        <Table
          fade={false}
          sx={{ maxHeight: 460, marginBottom: "26px" }}
          header={HEADER}
          items={items.map((item: PurchasedProductType) => {
            return {
              ...item,
              description: t(`features.product.type.${item.product}.title`),
            }
          })}
        />
      </Card>
    </Container>
  )
}

export default compose<ComponentType>(withPurchasedProducts)(PurchasedProducts)

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  margin: "42px 0 8px 0",
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap",
    flexDirection: "column",
  },
}))

const Card = styled(Paper)(({ theme }) => ({
  boxShadow: "12px 14px 23px -2px rgb(0 0 0 / 3%)",
  borderRadius: "26px",
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: "38px",
  marginBottom: "16px",
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    margin: "0 0 12px 0",
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    padding: "16px",
  },
}))
